module.exports = __webpack_public_path__ + "static/media/store-tele24.cb985e33.png";